import { render, staticRenderFns } from "./TableBoxAnalytics.vue?vue&type=template&id=16b8e6c7&scoped=true"
import script from "./TableBoxAnalytics.vue?vue&type=script&lang=js"
export * from "./TableBoxAnalytics.vue?vue&type=script&lang=js"
import style0 from "./TableBoxAnalytics.vue?vue&type=style&index=0&id=16b8e6c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b8e6c7",
  null
  
)

export default component.exports